import React from 'react';
import { Tag, TagLabel } from '@chakra-ui/react'
import { computeTagStatusColor } from '../../../utilities/ui';
import { transformString } from '../../../utilities/others';

export default function CustomTag (
    props: { 
        status: string, 
        size: string, 
        key?: string, 
        isIconOnly?: boolean,
        icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    }
) {
	const color = computeTagStatusColor(props.status);
	const text = transformString(props.status || 'noStatus');
	
    function renderIcon(){
        if (props.isIconOnly && props.icon) {
            return props.icon
        } else {
            return <TagLabel>{text}</TagLabel>
        }
    }

    return (
        <Tag
            size={props.size} 
            key={props.key} 
            variant='solid' 
            colorScheme='teal'
            backgroundColor={color}
        >
            {renderIcon()}
        </Tag>
	);
};